import { IAction } from 'core/interface/action';

export const SAVE_VALUES = 'save-social-media';

const defaultState = {
  socialMedia: null
};

export const SaveSocialMedia = (value: any | number[]) => ({
  type: SAVE_VALUES,
  payload: value
});

const socialMediaReducer = (
  state = defaultState,
  action: IAction<any | number[]>
) => {
  switch (action.type) {
    case SAVE_VALUES:
      return {
        ...state,
        socialMedia: action.payload
      };
    default:
      return state;
  }
};

export default socialMediaReducer;
